// extracted by mini-css-extract-plugin
module.exports = {"page":"TripsPageContent_page__U5D4Y","subtitle":"TripsPageContent_subtitle__Dnrp2"};